import { React, useEffect } from 'react'
import { Navigate, useNavigate, useLocation } from 'react-router-dom'
import styles from './OidcIdLogin.module.scss'
import Logo from '../../components/Logo'
import Card from '../../components/Card'
import { APP_NAME } from '../../utils/constants'
import Spinner from '../../components/Loader/Spinner'
import OIDCProvider from '../../components/OIDCProvider'
//
const OIDCLoginRedirect = () => {
  let isLocation = false
  let authCode = ''
  let state = ''
  let clientid=''
  let redirect_uri=''
  const location = useLocation()
  
  if (location !== '' && location !== undefined) {
    if (location.search.includes('code')) {
      isLocation = true
      authCode = new URLSearchParams(location.search).get('code') || ''
    }
     if (location.search.includes('state')) {
      isLocation = true
      state = new URLSearchParams(location.search).get('state') || ''
      redirect_uri=state.split('_')[2]
      clientid=state.split('_')[3]
     
    }
  }
// Inline styles keep this change self-contained; small, responsive, centered card
  const wrapperStyle = {
    minHeight: '60vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '24px'
  }

  const cardStyle = {
    background: 'white',
    borderRadius: 12,
    boxShadow: '0 6px 20px rgba(0,0,0,0.08)',
    padding: '28px 30px',
    maxWidth: 420,
    width: '100%',
    textAlign: 'center',
    boxSizing: 'border-box'
  }

  const titleStyle = {
    fontSize: 18,
    fontWeight: 600,
    marginBottom: 8,
    color: '#102A43'
  }

  const subtitleStyle = {
    fontSize: 14,
    marginBottom: 18,
    color: '#334E68'
  }

  const spinnerStyle = {
    width: 48,
    height: 48,
    borderRadius: '50%',
    border: '4px solid rgba(16,42,67,0.12)',
    borderTopColor: '#0B66C2',
    animation: 'spin 1s linear infinite',
    margin: '0 auto 14px'
  }
  if (isLocation) {
    return (
      authCode && (
         <div style={wrapperStyle}>
      <div style={cardStyle}>
        <div style={spinnerStyle} aria-hidden="true" />
        <div style={titleStyle}>Redirecting to sign in page...</div>
        <div style={subtitleStyle}>You will be sent to the secure login page shortly.</div>
        <div style={{ fontSize: 13, color: '#627D98' }}>If you are not redirected automatically, please wait or check your browser settings.</div>
        <OIDCProvider authCode={authCode} client_id={clientid} redirect_uri={redirect_uri} />
        {/* simple keyframes for the spinner; injected via style tag to keep file self-contained */}
        <style>{`@keyframes spin { from { transform: rotate(0deg) } to { transform: rotate(360deg) } }`}</style>
      </div>
    </div>
        // <div className={styles.base}>
        //   <div className={styles.container}>
        //     <div className={styles.logo}>
        //       <Logo color="#fff" />
        //     </div>

        //     <Card className={styles.loginCard}>
        //       <div className={styles.appName}>
        //         <span>{APP_NAME}</span>
        //       </div>
        //       <OIDCProvider authCode={authCode} client_id={clientid} redirect_uri={redirect_uri} />
        //       <div className={styles.loginPreference}>
        //         <Spinner /> Redirecting to sign in page...
        //       </div>
        //     </Card>
        //   </div>
        // </div>
      )
    )
  } else {
    return (
      <>
        <Navigate to="/Home" replace />
      </>
    )
  }
}

export default OIDCLoginRedirect
